import { serverApi } from "./serverApi";
import { ErrorType } from "../types/sharedTypes";
import { Folder } from "../types/testCaseTemplateFolderTypes";

export const testCaseTemplateFolderService = serverApi.injectEndpoints({
  endpoints: (build) => ({
    getAllFolder: build.query<Array<Folder>, string>({
      query: () => ({
        url: "/test-case-template-folder/all-folders"
      })
    }),
    createFolder: build.mutation<number, Folder>({
      query: (folder) => ({
        url: "/test-case-template-folder/folder",
        method: "POST",
        body: folder
      }),
      transformErrorResponse: (baseQueryReturnValue, meta): ErrorType => {
        return {
          status: meta?.response?.status,
          statusText: meta?.response?.statusText,
          message: (baseQueryReturnValue.data as any)?.errorCode
        }
      }
    }),
    updateFolder: build.mutation<string, Folder>({
      query: (folder) => ({
        url: "/test-case-template-folder/folder",
        method: "PUT",
        body: folder
      }),
      transformErrorResponse: (baseQueryReturnValue, meta): ErrorType => {
        return {
          status: meta?.response?.status,
          statusText: meta?.response?.statusText,
          message: (baseQueryReturnValue.data as any)?.errorCode
        }
      }
    }),
    deleteFolder: build.mutation<string, number>({
      query: (folderId) => ({
        url: "/test-case-template-folder/folder",
        method: "DELETE",
        params: { id: folderId }
      }),
      transformErrorResponse: (baseQueryReturnValue, meta): ErrorType => {
        return {
          status: meta?.response?.status,
          statusText: meta?.response?.statusText,
          message: (baseQueryReturnValue.data as any)?.errorCode
        }
      }
    })
  })
});

export const {
  useGetAllFolderQuery,
  useCreateFolderMutation,
  useUpdateFolderMutation,
  useDeleteFolderMutation
} = testCaseTemplateFolderService;